'use strict';

angular.module('preferedPropertiesController', [])

.controller('PreferedPropertiesController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','AgencyService', 'BuyerService', 'CommonService',
    function (appInfo, $scope, $rootScope, $log, $location, $window, AgencyService, BuyerService, CommonService) {    
    
    $scope.page = 'preferedProperties';
    var currentUser = $rootScope.currentUser;
    $scope.start = 0;
    $scope.autoLoad = true;
    $scope.preferedProperties = [];
    $scope.watchlist = [];
    $scope.preferences = {};

    $scope.propertyDetail = {};
    $scope.openHomeDetail = {};
    $scope.propertyPosts = [];
    $scope.propertyRefs = [];
    $scope.propertyMicrositeURL = {};

    $scope.currentPageSection = 'list';  //can be propertyDetail, enquiryForm depending upon what section is displayed
    $scope.previousPageSection = 'list';
    $scope.showWeeklyRentReturn = false;
    $scope.weeklyRentReturn = '';
    $scope.showOtherProperties = false;   
    $scope.otherPropertiesCount = 0;   

    
    var loadProperties = function() {
        $scope.currentPageSection = 'loading';
        var upstreamCall = true;
        if(!$rootScope.loading) {
            $rootScope.loading = true;
            upstreamCall = false;
        }

        BuyerService.getPreferences()
        .then(function(data) {
            $rootScope.loading = true;

            if(data.length > 0) {
                $scope.preferences = data[0];
                var suburbs = JSON.parse($scope.preferences.suburbs);
                var propertyTypes = JSON.parse($scope.preferences.propertyTypes);

                $scope.preferences.suburbs = suburbs;
                $scope.preferences.propertyTypes = propertyTypes; 

            } else {
                $scope.preferences = {};
                if($rootScope.buyerPropertyRequestPreferences) {
                   $scope.preferences = $rootScope.buyerPropertyRequestPreferences;;
                }
            } 
            $rootScope.loading = true;
            return BuyerService.getPreferedProperties($scope.preferences, $scope.start);
        })
        .then(function(data) {
            $rootScope.loading = true;
            $scope.preferedProperties = data;

            angular.forEach($scope.preferedProperties, function(property){

                if(property.isNearBy){
                    if(!$scope.showOtherProperties){
                        $scope.showOtherProperties= true;
                    }
                    $scope.otherPropertiesCount++;
                }
            });

            return BuyerService.getWatchlist();
        })
        .then(function(data) {
            $rootScope.loading = true;
            $scope.watchlist = data;
            angular.forEach($scope.preferedProperties, function(property){

                $scope.propertyRefs.push(property.propertyRef);
                var index = CommonService.indexByField($scope.watchlist, 'propertyId', property.propertyId);
                if(index > -1) {
                    property.watched = true;
                    property.watchlistId = $scope.watchlist[index].id;
                } else {
                    property.watched = false;
                    property.watchlistId = 0;
                }
            });
            if($scope.preferedProperties.length > 0) {
               $scope.start = $scope.preferedProperties.length + 1;
            }
            return BuyerService.getPropertyMicrositeURL($scope.propertyRefs);  
        })
        .then(function(data) {
            $rootScope.loading = true;
            $scope.propertyMicrositeURL = data;
        })
        .catch(function(err) {
            console.log(err);
            if($scope.preferedProperties.length > 0) {
               $scope.start = $scope.preferedProperties.length + 1;
            }
            $rootScope.loading = false;
        })
        .finally(function(data) {
            // loadPreferences();
            if (!upstreamCall) {
                $rootScope.loading = false;
            }
             $scope.currentPageSection = 'list';
        });

        //load preferences from db
      
    }

    var init = function() {
        $scope.currentPageSection = 'list';
        $scope.previousPageSection = 'list';
        
        $scope.propertyDetail = {};
        BuyerService.getBuyerPropertyRequestPreferences()
        .then(function(data) {
            loadProperties();    
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){

        });
        
    }

    $scope.addToWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.addToWatchlist(property.propertyId)
        .then(function(data){
            property.watched = true;
            property.watchlistId = data;
            // loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.removeFromWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.removeFromWatchlist(property.watchlistId)
        .then(function(data){
            property.watched = false;
            property.watchlistId = 0;
            // loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.displayPageSection =  function(section) {
      return (section == $scope.currentPageSection);
    }

    $scope.showPageSection = function(property, section) {
        $scope.page = section;
        $scope.previousPageSection = $scope.currentPageSection;
        $scope.currentPageSection = section;
        $scope.propertyDetail = property;
        $scope.openHomeDetail = {};
        if (property.openHome[0].length) {
            $scope.openHomeDetail = property.openHome[0][0];    
        }
        
    }

    $scope.hidePageSection = function() {
        var previousPage = $scope.currentPageSection;
        $scope.page = 'preferedProperties';
        $scope.currentPageSection = $scope.previousPageSection;
        $scope.previousPageSection = previousPage;
        $scope.propertyDetail = {};
        $scope.openHomeDetail = {};
    }

    $scope.displayWeeklyRentReturn = function(property) {
        var propertyAddress = property.streetUnit + ' '  + property.streetRef + ' ' + property.streetName + ' ' + property.streetType; 
        var noteText = "Buyer clicked approximate rent return for the property: " + propertyAddress;
        BuyerService.addNote(noteText)
        .then(function(data){
            $scope.showWeeklyRentReturn = true;
            $scope.weeklyRentReturn = property.weeklyRentReturn;    
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){

        });
    }


    $scope.loadMorePreferedProperties = function() {
        if($scope.displayPageSection('list') && $scope.start > 0 && !$rootScope.loading && $scope.autoLoad) {
           $rootScope.loading = true;

           BuyerService.getPreferedProperties($scope.preferences, $scope.start)
            .then(function(data){
                angular.forEach(data, function(property){
                    if(property.isNearBy){
                        if(!$scope.showOtherProperties){
                            $scope.showOtherProperties= true;
                        }
                        $scope.otherPropertiesCount++;
                    }

                    $scope.propertyRefs.push(property.propertyRef);
                    var index = CommonService.indexByField($scope.watchlist, 'propertyId', property.propertyId);
                    if(index > -1) {
                        property.watched = true;
                        property.watchlistId = $scope.watchlist[index].id;
                    } else {
                        property.watched = false;
                        property.watchlistId = 0;
                    }
                    $scope.preferedProperties.push(property);
                });
                if($scope.preferedProperties.length > 0) {
                   $scope.start = $scope.preferedProperties.length + 1;
                }


                if($scope.start >= $rootScope.totalSearch) {
                    $scope.autoLoad = false;
                }
                return BuyerService.getPropertyMicrositeURL($scope.propertyRefs);  
            })
            .then(function(data){
                $scope.propertyMicrositeURL = data;
            })
            .catch(function(err) {
            })
            .finally(function(data){
                $rootScope.loading = false;
            }); 
        }
    }

    $scope.getPropertyURL = function(propertyRef) {
        var propertyURL = 'http://www.wiseberry.com.au/property/' + propertyRef;
        if($scope.propertyMicrositeURL[propertyRef]) {
            propertyURL = $scope.propertyMicrositeURL[propertyRef];
        }
        return propertyURL;
    }

    init();

}]);